export default "__VITE_ASSET__Dz6K_k9b__"